import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LecturesWorkshopsListComponent } from './lectures-workshops-list/lectures-workshops-list.component';
import { LecturesWorkshopsCreateComponent } from './lectures-workshops-create/lectures-workshops-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: LecturesWorkshopsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: LecturesWorkshopsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'lectures-workshops-create/:id',
        component: LecturesWorkshopsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LecturesWorkshopsRoutingModule { }
